import React, { useContext, useEffect } from "react";

import { Outlet, useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Context } from "../index";
import "./AdminLayout.css";

export default observer(function AdminLayout() {
  const { store, adminStore } = useContext(Context);
  const navigate = useNavigate();

  useEffect(() => {
    adminStore.fetchModules();
  }, []);

  const handleLogout = () => {
    store.logout();
    navigate("/"); // редирект на главную
  };

  return (
    <div className="admin-layout">
      <header className="admin-header">
        <h2 className="H2-admin">Админ-панель</h2>
        <div className="admin_btns">
          <button
            onClick={() => navigate("/organizations")}
            className="btn_logout"
          >
            вернуться в систему
          </button>
          {/* <button onClick={() => navigate('/users')} className="btn_logout">
            пользователи
          </button> */}

          <button onClick={handleLogout} className="btn_logout">
            Выйти
          </button>
        </div>
      </header>

      <div className="admin-container">
        <nav className="admin-sidebar">
          <ul>
            <li onClick={() => navigate("/admin/logs")}>Логи</li>
            <li onClick={() => navigate("/admin/logs-new-protocol")}>
              Логи (новый протокол)
            </li>
            <li onClick={() => navigate("/admin/DBlogs")}>Логи в БД</li>
            <li onClick={() => navigate("/admin/updatePanel")}>Обновление</li>
            <li onClick={() => navigate("/admin/devlog")}>DevLogs</li>
            {/* `C.4`: раздел адресатов тревог — только root; остальным пункта нет. */}
            {store.user?.role === "root" ? (
              <li onClick={() => navigate("/admin/alarm-recipients")}>
                Адресаты тревог
              </li>
            ) : null}
            {/* п. 23 (`DEV-68`): внесение по договору. */}
            <li onClick={() => navigate("/admin/invitations")}>
              Внесение по договору
            </li>
          </ul>
        </nav>

        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
});
